import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { imgUrl, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useSettings } from "../context/SettingsContext";

export default function Login() {
  const { login } = useAuth();
  const { settings } = useSettings();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Καλώς ήρθατε!");
      nav(u.role === "admin" ? "/admin" : "/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Σφάλμα σύνδεσης");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full px-4 py-3 rounded-sm border border-[#E5E9E4] bg-white text-sm focus:border-[#1E3A2F] focus:ring-1 focus:ring-[#1E3A2F] outline-none";

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="text-center mb-8">
        <img src={imgUrl(settings?.logo || "/logo.jpeg")} alt="logo" className="h-16 w-16 rounded-md object-cover mx-auto mb-4" />
        <h1 className="font-serif-display text-3xl text-[#1E3A2F]">Σύνδεση</h1>
        <p className="text-[#536D61] mt-1 text-sm">Καλώς ήρθατε ξανά</p>
      </div>
      <form onSubmit={submit} className="space-y-4 bg-white border border-[#E5E9E4] rounded-sm p-6">
        <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
        <input data-testid="login-password" type="password" placeholder="Κωδικός" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
        <button data-testid="login-submit" disabled={loading} className="w-full bg-[#1E3A2F] text-white py-3 rounded-sm font-medium hover:bg-[#111C18] disabled:opacity-60">
          {loading ? "Σύνδεση..." : "Σύνδεση"}
        </button>
      </form>
      <p className="text-center text-sm text-[#536D61] mt-6">
        Δεν έχετε λογαριασμό; <Link to="/register" className="text-[#1E3A2F] font-medium underline">Εγγραφή</Link>
      </p>
    </div>
  );
}
